export default Object.freeze({
  MALE: 'M.',
  FEMALE: 'Mme.',
});
